// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"2edd3b68","316":"3c840c21","421":"22457ee2","453":"a3d5829a","455":"046e04e6","466":"344a3133","680":"74260f03","802":"72c9398f","866":"175c92ed","868":"2100b120","869":"4f8761df","923":"b2970591","977":"3eed2077"}[chunkId] + ".chunk.js";
};